<template>
<div class="sa-video-call">
    <div class="sa-dialer">
        <div class="sa-ringer">
            <div class="sa-connecting-call sa-call-animate sa-call-animated sa-call-css">
                <figure class="sa-avtar sa-avtar-circle sa-avtar-md">
                    <img v-if="$parent.payloadUserDetails.img" :src="$parent.payloadUserDetails.img" alt="Doctor" class="sa-img-cover" />
                    <img v-else :src="$parent.unknownImg" alt="Doctor" class="sa-img-cover" />
                </figure>
            </div>
        </div>
        <div class="sa-phone-hdr">
            <div class="sa-phone-hdr-tit">
                <strong>Calling {{ $parent.payloadUserDetails.pname }}</strong>
            </div>
        </div>
        <ul class="sa-phone-list">
            <li @click="endCall" class="sa-red-bg">
                <i class="icon-call2 sa-white-text"></i>
            </li>
        </ul>
    </div>
</div>
</template>

<script>
import {
    bus
} from "../../main";

export default {
    name: "Ringer",
    methods: {
        endCall() {
            bus.$emit("endCall");
        },
    },
    mounted() {
        console.log(this.$parent.payloadUserDetails)
    }
};
</script>
